export async function getPrompt(
    url,
    figure,
    onPrompt,
    prompt_instructions,
    onChunk,
    abortController,
    refresh = false
) {
    let chunks = '',
        done = false,
        cached = false,
        prompt;

    try {
        const payload = JSON.stringify({
            action: 'stream_insights',
            payload: {
                figure: JSON.stringify(figure),
                prompt_instructions: prompt_instructions,
                refresh,
            },
        });
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: payload,
            signal: abortController.signal,
        });
        if (response.status !== 200) {
            const text = await response.text();
            throw new Error(text);
        }
        const decoder = new TextDecoder();
        const reader = response.body.getReader();

        while (!done) {
            const chunk = await reader.read();
            done = chunk.done;
            const value = decoder.decode(chunk.value);

            if (value.startsWith('ERROR:')) {
                throw new Error(value.split('ERROR:').reverse()[0]);
            }

            if (!prompt) {
                const data = JSON.parse(value);
                prompt = data.prompt;
                cached = data.cached;
                onPrompt(prompt);
            } else {
                chunks += value;
                onChunk(value);
            }
        }
        return {text: chunks, cached};
    } catch (error) {
        if (abortController.signal.aborted) {
            onChunk(`${chunks}\n\nInsights stopped generating...`);
            return {text: chunks, cached};
        }
        console.error(error);
        throw error;
    }
}
